import { render, staticRenderFns } from "./EditBoxRangeSelect.vue?vue&type=template&id=b66fa03e&scoped=true&"
import script from "./EditBoxRangeSelect.vue?vue&type=script&lang=js&"
export * from "./EditBoxRangeSelect.vue?vue&type=script&lang=js&"
import style0 from "../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=b66fa03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66fa03e",
  null
  
)

export default component.exports